var render, staticRenderFns
import script from "./Layout.vue?vue&type=script&lang=js&"
export * from "./Layout.vue?vue&type=script&lang=js&"
import style0 from "./Layout.vue?vue&type=style&index=0&id=4a89fd15&prod&lang=scss&scoped=true&"
import style1 from "./Layout.vue?vue&type=style&index=1&id=4a89fd15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89fd15",
  null
  
)

export default component.exports